// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updatePaymentProfile as updatePaymentProfileApi } from "@insite/client-framework/Services/AccountService";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/PaymentProfiles/Handlers/UpdatePaymentProfile";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        props.apiResult = await updatePaymentProfileApi(props.parameter);
    } catch (error) {
        (props as any).error = error;
        return false;
    }
};
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
